import { IntlProvider } from 'react-intl';
import { PureComponent } from 'react';
import { isNull, map } from 'es-toolkit/compat';

import { CombinedPurchaseHistory } from '@tock/shared/utils/patronUtils';
import { Typography } from 'omakase';
import { getSettings } from 'settings/AppSettings';
import TransactionHistoryItem from 'components/account/TransactionHistoryItem';

interface Props {
  history: CombinedPurchaseHistory[];
}

export default class TransactionHistory extends PureComponent<Props> {
  render() {
    if (isNull(this.props.history)) {
      return (
        <Typography variant="body02">
          You need to confirm your email address before you can view your transactions.
        </Typography>
      );
    }

    if (this.props.history.length === 0) {
      return <Typography variant="body02">You don't have any transactions.</Typography>;
    }

    const appSettings = getSettings(__ENV__);

    return (
      <IntlProvider locale={appSettings.USER_LOCALE}>
        <div className="TransactionHistory">
          <header className="TransactionHistory-row TransactionHistory-row--header">
            <div className="TransactionHistory-cell TransactionHistory-cell--header TransactionHistory-cell--date">
              <Typography color="inherit" component="span" variant="body02">
                Date
              </Typography>
            </div>

            <div className="TransactionHistory-cell TransactionHistory-cell--header TransactionHistory-cell--details">
              <Typography color="inherit" component="span" variant="body02">
                Details
              </Typography>
            </div>

            <div className="TransactionHistory-cell TransactionHistory-cell--header TransactionHistory-cell--amount">
              <Typography color="inherit" component="span" variant="body02">
                Amount
              </Typography>
            </div>
          </header>

          {map(this.props.history, (transaction) => (
            <TransactionHistoryItem item={transaction} key={transaction.id} />
          ))}
        </div>
      </IntlProvider>
    );
  }
}
